import type { HTMLAttributes } from "react";
import { cn } from "~/lib/utils";

interface BoxProps extends HTMLAttributes<HTMLDivElement> {
  title: string;
  badge?: string;
  sub: string;
  className?: string;
  titleClassName?: string;
}

const box_style = "flex-1 rounded-lg border border-white/5 bg-white/5 px-3 py-2 backdrop-blur-sm";
const title_style = "text-right text-2xl font-bold text-cyan-400";

export default function Box({
  title,
  sub,
  badge,
  className,
  titleClassName,
  ...props
}: BoxProps) {
  return (
    <div className={cn(box_style, className)} {...props}>
      <div dir="auto" className={cn(title_style, titleClassName)}>
        {title}
        {badge && <span className="text-sm font-medium text-sky-200/80">{` ${badge} `}</span>}
      </div>
      <div className="text-sm text-slate-400">{sub}</div>
    </div>
  );
}
